// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5a960ab6","726":"2efc1f8a"}[chunkId] + ".chunk.js";
};